import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * @description 获取员工列表（普通商户/api商户）
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getStaffList(data){
    return request.get(`${BASE_URL}/staff/list`,data)
  },

  /**
   * @description 新增用户信息（普通商户/api商户）
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  createStaff(data) {
    return request.post(`${BASE_URL}/staff/store`,data)
  },

  /**
   * @description 编辑用户信息（普通商户/api商户）
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  updateStaff(id, data) {
    return request.put(`${BASE_URL}/staff/update/${id}`, data)
  },

  /**
   * @description 用户详情（普通商户/api商户）
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  viewStaff(id, data) {
    return request.get(`${BASE_URL}/staff/view/${id}`,data)
  },

   /**
   * @description 移除当前用户（普通商户/api商户）
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  deleteStaff(data) {
    return request.post(`${BASE_URL}/staff/move_user`, data)
  }
}